import Vue from "vue";

/**
 * RX COMMON ROUTER PAGE PATH CONST
 */
export const RX_PAGE = {
  /**
   * 레이아웃 관련 페이지
   */
  MAIN: "/", // Main 화면
  LOGIN: "/login", // 로그인 페이지
  HOME: "/home", // Home 화면

  /**
   * 오류 및 안내 페이지
   */
  NOT_FOUND_PAGE: "/404", //404페이지 직접이동
  UNAUTHORIZED_PAGE: "/unauthorizedPage", //403페이지

  /**
   * 동적 URI 주소 생성
   * @param {*} url
   * @param {*} params
   */
  genUri: function(uri, params) {
    let generatedUri = uri;
    if (params) {
      const keys = Object.keys(params);
      keys.forEach((param) => {
        let reg = new RegExp(`:${param}`, "gi" );
        generatedUri = generatedUri.replace(reg, params[param]);
      });
    }
    return generatedUri;
  },
};

Vue.prototype.RX_PAGE = redworksPage();

function redworksPage() {
  // 1. @/*/js/consts 폴더 하위 js 파일 가져오기
  const pages = require.context("@", true, /routes\/[A-Za-z0-9-_,\s]+\.js$/i);

  // 2. RX_PAGE 가져오기
  let resultPage = Object.assign({}, RX_PAGE);

  // 3. RX_PAGE(/redworks/js/consts/rx-const.js 제외)에 다른 PAGE 경로 담기
  pages.keys().forEach((key) => {
    const split = key.split("/");
    if (
      split &&
      split.length > 3 &&
      split[1] != "redworks" &&
      split[3] != "index.js"
    ) {
      const addPage = pages(key).default;
      resultPage = Object.assign(resultPage, addPage);
    }
  });
  return resultPage;
}